/*
 * Copyright (c) 2020 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of 2020 SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:	Settings.js
 *
 * Description:	Generic Greenlight Settings code.
 */

(function () {

    "use strict";

    /**
	 * Creates a new Settings object.
	 * @param {object} settings - The settings to be used.
	 */
	function Settings(oUserSettings, oConsumerSettings) {
		
		// Set the settings.
		this.g_oUserSettings = oUserSettings;
		this.g_oConsumerSettings = oConsumerSettings;

		// These settings are set as constants, and require the viewer to be re-loaded for changes to take effect.
		this.c_iSkinType = oUserSettings.SkinType;
		this.c_szDateFormat = oUserSettings.DateFormat + " HH:mm:ss";

		// Constants to be set in the aspx page.
		this.c_szChangeRequiresReload = "";

		// If the settings menu is in animation.
		this.g_bSettingsAnimating = false;

		// If the next click event should not auto close the menu.
		this.g_bIgnoreNextClickEvent = false;
	};

	/**
	 * Initialises the settings.
	 */
	Settings.prototype.intialiseSettings = function () {

		// Apply any locked settings.
		g_oSettings.applyLockedSettings();

		// Update the settings menu with the initial settings.
		g_oSettings.updateSettingsMenu();
	};

	/**
	 * Toggles the settings menu.
	 */
	Settings.prototype.toggleSettingsMenu = function () {
		// Close all active bubbles.
		g_oGreenlightMessages.closeBubbles();

		// If we are not already animating the settings menu.
		if (!g_oSettings.g_bSettingsAnimating) {

			// Set that the menu is currently animating.
			g_oSettings.g_bSettingsAnimating = true;

			// If the user settings are currently shown.
			if ($("#divSettings").css("display") == "none") {

				// Ensure the menu is just off screen.
				$("#divSettings").css("right", 1 - + $("#divSettings").width());

				// Show the menu.
				$("#divSettings").show();

				// Slide the menu in from the right.
				$("#divSettings").animate({
					right: 7
				}, 'swing', function () {

					// Set that we are no longer animating.
					g_oSettings.g_bSettingsAnimating = false;
				});
			}
			// If the user settings are currently not shown.
			else {

				// Slide the menu out to the right.
				$("#divSettings").animate({
					right: 1 - + $("#divSettings").width()
				}, 'swing', function () {

					// Hide the menu once the animation has finished.
					$("#divSettings").hide();

					// Set that we are no longer animating.
					g_oSettings.g_bSettingsAnimating = false;
				});
			}
		}
	};

	/**
	 * Applies any locked settings.
	 * @param {object} oUserSettings - The user settings.
	 * @param {object} oConsumerSettings - The consumer settings.
	 */
	Settings.prototype.applyLockedSettings = function () {
		
		// If the text comparison accuracy setting is locked, force the consumer setting and lock the option.
		if (g_oSettings.g_oConsumerSettings.LockTextComparisonAccuracy) {
			g_oSettings.g_oUserSettings.TextComparisonAccuracy = g_oSettings.g_oConsumerSettings.TextComparisonAccuracy;
			$("#setting_TextComparisonAccuracy").prop("disabled", "disabled");
			$("#setting_TextComparisonAccuracy_Lock").css("display", "inline-block");
		}

		// If the text comparison case sensitivity setting is locked, force the consumer setting and lock the option.
		if (g_oSettings.g_oConsumerSettings.LockTextComparisonCaseSensitivity) {
			g_oSettings.g_oUserSettings.TextComparisonCaseSensitivity = g_oSettings.g_oConsumerSettings.TextComparisonCaseSensitivity;
			$("#setting_TextComparisonCaseSensitivity").prop("disabled", "disabled");
			$("#setting_TextComparisonCaseSensitivity_Lock").css("display", "inline-block");
		}

		// If the text comparison bold italic setting is locked, force the consumer setting and lock the option.
		if (g_oSettings.g_oConsumerSettings.LockTextComparisonBoldItalicDetection) {
			g_oSettings.g_oUserSettings.TextComparisonBoldItalicDetection = g_oSettings.g_oConsumerSettings.TextComparisonBoldItalicDetection;
			$("#setting_TextComparisonBoldItalicDetection").prop("disabled", "disabled");
			$("#setting_TextComparisonBoldItalicDetection_Lock").css("display", "inline-block");
		}

		// If the text comparison whitespace setting is locked, force the consumer setting and lock the option.
		if (g_oSettings.g_oConsumerSettings.LockTextComparisonWhitespaceDetection) {
			g_oSettings.g_oUserSettings.TextComparisonWhitespaceDetection = g_oSettings.g_oConsumerSettings.TextComparisonWhitespaceDetection;
			$("#setting_TextComparisonWhitespaceDetection").prop("disabled", "disabled");
			$("#setting_TextComparisonWhitespaceDetection_Lock").css("display", "inline-block");
		}

		// If the text auto selection setting is locked, force the consumer setting and lock the option.
		if (g_oSettings.g_oConsumerSettings.LockTextComparisonAutoSelection) {
			g_oSettings.g_oUserSettings.TextComparisonAutoSelection = g_oSettings.g_oConsumerSettings.TextComparisonAutoSelection;
			g_oSettings.g_oUserSettings.TextComparisonAutoSelectionFuzzyThreshold = g_oSettings.g_oConsumerSettings.TextComparisonAutoSelectionFuzzyThreshold;
			$("#setting_TextComparisonAutoSelection").prop("disabled", "disabled");
			$("#setting_TextComparisonAutoSelection_Lock").css("display", "inline-block");
			$("#setting_TextComparisonAutoSelection_FuzzyThreshold").prop("disabled", "disabled");
			$("#setting_TextComparisonAutoSelection_FuzzyThreshold_Lock").css("display", "inline-block");
		}
	};

	/**
	 * Updates the settings menu with the user settings.
	 */
	Settings.prototype.updateSettingsMenu = function () {

		// Update the scroll preference.
		g_oSettings.updateSettingScrollPreference(false);

		// Update the zoom speed.
		g_oSettings.updateSettingZoomSpeed(false);

		// Update the zoom increment.
		g_oSettings.updateSettingZoomIncrements(false);

		// Update the alignment preference.
		g_oSettings.updateSettingAlignmentPreference(false);

		// Update the highlight preference.
		g_oSettings.updateSettingHighlightPreference(false);

		// Update the skin type.
		g_oSettings.updateSettingSkinType(false);

		// Update the show annotations setting.
		g_oSettings.updateSettingShowAnnotations(false);

		// Update the show annotation numbers setting.
		g_oSettings.updateSettingShowAnnotationNumbers(false);

		// Update the measurement units.
		g_oSettings.updateSettingMeasurementPreference(false);

		// Update the annotation colour.
		g_oSettings.updateSettingAnnotationColour(false);
		
		// Update the overprint colour.
		g_oSettings.updateSettingOverprintColour(false);

		// Update the date format.
		g_oSettings.updateSettingDateFormat(false);

		// Update the text comparison highlight colour.
		g_oSettings.updateSettingTextComparisonHighlightColour(false);

		// Update the text comparison accuracy.
		g_oSettings.updateSettingTextComparisonAccuracy(false);

		// Update the text comparison sensitivity.
		g_oSettings.updateSettingTextComparisonCaseSensitivity(false);

		// Update the text comparison bold italic detection.
		g_oSettings.updateSettingTextComparisonBoldItalicDetection(false);

		// Update the text comparison whitespace detection.
		g_oSettings.updateSettingTextComparisonWhitespaceDetection(false);

		// Update the text comparison Auto Selection.
		g_oSettings.updateSettingTextComparisonAutoSelection(false);

		// Update the text comparison Auto Selection Fuzzy Threshold.
		g_oSettings.updateSettingTextComparisonFuzzyThreshold(false);
	};

	/**
	 * Updates the setting for showing annotations.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingShowAnnotations = function (bSyncSettings) {

		// Update the show annotations setting in the settings menu.
		$("#settings_ShowAnnotationsToggle").prop('checked', g_oSettings.g_oUserSettings.ShowAnnotations);

		// Update the class of the hide annotations icon.
		if (g_oSettings.g_oUserSettings.ShowAnnotations) {
			$("#HideAnnotations").removeClass("ShowAnnotations");
		}
		else {
			$("#HideAnnotations").addClass("ShowAnnotations");
		}
		
		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for showing annotation numbers.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingShowAnnotationNumbers = function (bSyncSettings) {

		// Update the show annotation numbers setting in the settings menu.
		$("#settings_ShowAnnotationNumbersToggle").prop('checked', g_oSettings.g_oUserSettings.ShowAnnotationNumbers);

		// Update the annotation number icon in the annotation slideout.
		$("#btnShowAnnNumbers").attr("src", g_oSettings.g_oUserSettings.ShowAnnotationNumbers ? "img/Show-Ann-Numbers_24.png" : "img/Hide-Ann-Numbers_24.png");

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for scroll preference.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingScrollPreference = function (bSyncSettings) {
		
		// Update the scroll preference in the settings menu.
		$("#setting_ScrollPreference").val(g_oSettings.g_oUserSettings.ScrollPreference);

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for zoom speed.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingZoomSpeed = function (bSyncSettings) {

		// Update the zoom speed in the settings menu.
		$("#setting_ZoomSpeed").val(g_oSettings.g_oUserSettings.ZoomSpeed);

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for zoom increments.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingZoomIncrements = function (bSyncSettings) {

		// Update the zoom increments in the settings menu.
		$("#setting_ZoomIncrements").val(g_oSettings.g_oUserSettings.ZoomIncrements);

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for alignment preference.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingAlignmentPreference = function (bSyncSettings) {

		// Update the scroll preference in the settings menu.
		$("#setting_AlignmentPreference").val(g_oSettings.g_oUserSettings.AlignmentPreference);

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for highlight preference.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingHighlightPreference = function (bSyncSettings) {

		// Update the scroll preference in the settings menu.
		$("#setting_HighlightPreference").val(g_oSettings.g_oUserSettings.HighlightPreference);

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for text comparison highlight colour.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingTextComparisonHighlightColour = function (bSyncSettings) {

		// Update the highlight colour in the settings menu.
		$("#setting_TextComparisonHighlightColour").val(g_oSettings.g_oUserSettings.TextComparisonHighlightColour);

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for text comparison accuracy.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingTextComparisonAccuracy = function (bSyncSettings) {

		// Update the preference in the settings menu.
		$("#setting_TextComparisonAccuracy").val(g_oSettings.g_oUserSettings.TextComparisonAccuracy);

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for text comparison sensitivity.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingTextComparisonCaseSensitivity = function (bSyncSettings) {

		// Update the preference in the settings menu.
		$("#setting_TextComparisonCaseSensitivity").val(g_oSettings.g_oUserSettings.TextComparisonCaseSensitivity);

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for text comparison bold italic detection.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingTextComparisonBoldItalicDetection = function (bSyncSettings) {

		// Update the preference in the settings menu.
		$("#setting_TextComparisonBoldItalicDetection").val(g_oSettings.g_oUserSettings.TextComparisonBoldItalicDetection);

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for text comparison whitespace detection.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingTextComparisonWhitespaceDetection = function (bSyncSettings) {

		// Update the preference in the settings menu.
		$("#setting_TextComparisonWhitespaceDetection").val(g_oSettings.g_oUserSettings.TextComparisonWhitespaceDetection);

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for text comparison whitespace detection.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingTextComparisonAutoSelection = function (bSyncSettings) {

		// Update the preference in the settings menu.
		$("#setting_TextComparisonAutoSelection").val(g_oSettings.g_oUserSettings.TextComparisonAutoSelection);

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for text comparison fuzzy threshold.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingTextComparisonFuzzyThreshold = function (bSyncSettings) {
		// Update the preference in the settings menu.
		$("#setting_TextComparisonAutoSelection_FuzzyThreshold").val(g_oSettings.g_oUserSettings.TextComparisonAutoSelectionFuzzyThreshold);

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for text comparison fuzzy threshold.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingTextComparisonMinMatchWords = function (bSyncSettings) {
		// Update the preference in the settings menu.
		$("#textComparison_FullDocumentSelection_inputMinMatchWords").val(g_oSettings.g_oUserSettings.TextComparisonFullDocumentSelectionMinMatchWords);

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

		/**
	 * Updates the setting for text comparison fuzzy threshold.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingTextComparisonMatchFromDocument = function (bSyncSettings) {
		// Update the preference in the settings menu.
		$("#textComparison_FullDocumentSelection_selMatchFromDocument").val(g_oSettings.g_oUserSettings.TextComparisonFullDocumentSelectionMatchFromDocument);

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for measurement preference.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingMeasurementPreference = function (bSyncSettings) {

		// Update the measurement preference in the settings menu.
		$("#settings_MeasurementPreference").val(g_oSettings.g_oUserSettings.UseMetricUnits ? 1 : 0);

		// Update the unit icons.
		$("#TechToolsUnitsImg").attr("src", g_oSettings.g_oUserSettings.UseMetricUnits ? "img/Measure-Metric_24.png" : "img/Measure-Imperial_24.png");
		$("#OffsetUnitsImg").attr("src", g_oSettings.g_oUserSettings.UseMetricUnits ? "img/Measure-Metric_24.png" : "img/Measure-Imperial_24.png");
		$("#AlignmentUnitsImg_Viewer").attr("src", g_oSettings.g_oUserSettings.UseMetricUnits ? "img/Measure-Metric_24.png" : "img/Measure-Imperial_24.png");
		$("#AlignmentUnitsImg_Compare").attr("src", g_oSettings.g_oUserSettings.UseMetricUnits ? "img/Measure-Metric_24.png" : "img/Measure-Imperial_24.png");
		$("#GuidedUnitsImg_Compare").attr("src", g_oSettings.g_oUserSettings.UseMetricUnits ? "img/Measure-Metric_24.png" : "img/Measure-Imperial_24.png");

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for skin type.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingSkinType = function (bSyncSettings) {

		// Update the skin type in the settings menu.
		$("#setting_SkinType").val(g_oSettings.g_oUserSettings.SkinType);

		// Sync the settings if required, and show the reload warning.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
			g_oGreenlightMessages.displayWarningBubble(g_oSettings.c_szChangeRequiresReload);
		}
	}

	/**
	 * Updates the setting for the overprint colour.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingOverprintColour = function (bSyncSettings) {

		// Update the overprint colour in the settings menu.
		$("#setting_OverprintColour").val(g_oSettings.g_oUserSettings.OverprintColour);

		// Update the overprint colour in the separations slideout.
		$("#clrSelectOverprintColour").val(g_oSettings.g_oUserSettings.OverprintColour);

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for the annotation colour.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingAnnotationColour = function (bSyncSettings) {

		// Update the annotation colour in the settings menu.
		$("#setting_AnnotationColour").val(g_oSettings.g_oUserSettings.AnnotationColour);

		// Update the annotation colour in the annotation drop down if loaded.
		if (g_oAnnotations.annotationColourChangeUI != null && g_oAnnotations.annotationColourChangeUI != undefined) {
			g_oAnnotations.annotationColourChangeUI();
		}

		// Sync the settings if required.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
		}
	};

	/**
	 * Updates the setting for the date format.
	 * @param {bool} bSyncSettings - If the settings should be synced to the database.
	 */
	Settings.prototype.updateSettingDateFormat = function (bSyncSettings) {

		// Update the date format in the settings menu.
		$("#setting_DateFormat").val(g_oSettings.g_oUserSettings.DateFormat);

		// Sync the settings if required, and show the reload warning.
		if (bSyncSettings) {
			g_oSettings.syncSettings();
			g_oGreenlightMessages.displayWarningBubble(g_oSettings.c_szChangeRequiresReload);
		}
	};

	/**
	 * Syncs the settings to the database.
	 */
	Settings.prototype.syncSettings = function () {

		var oJSON = {
			SessionId: g_szSessionId,
			UserSettings: g_oSettings.g_oUserSettings
		};

		$.post({
			url: "UserDetails/UpdateUserSettings",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			cache: false,
			success: function (oResponse) {
				// Only need to display a message if this failed.
				if (!oResponse.Success) {
					g_oGreenlightMessages.displayErrorBubble(displayErrorContentHTML(oResponse.Errors));
				}
			}
		});
	};

	/**
	 *	Setting Auto Closing.
	 */
	$(document).on('click', function (event) {

		// If we are not already animating the settings menu, the settings menu is curreny open, and we want to close the menu.
		if (!g_oSettings.g_bSettingsAnimating && $("#divSettings").css("display") != "none" && !g_oSettings.g_bIgnoreNextClickEvent) {

			// If the click is outside of settings menu and not on the setting cog.
			if ($(event.target).parents("#divSettings").length == 0 && event.target.id != "divSettings") {

				// Close the combo control.
				g_oSettings.toggleSettingsMenu();
			}
		}
		// If we have ignored this click event.
		else if (g_oSettings.g_bIgnoreNextClickEvent) {

			// Set that we dont want to ignore the next one.
			g_oSettings.g_bIgnoreNextClickEvent = false;
		}
	});

    // Add the viewer object to the window.
    window.Settings = Settings;
}());